import {getTime, startOfDay, toDate} from "./core";
import {formatDMYDash, formatISO} from "./format";

export function now() {
    return new Date();
}

export function today() {
    return formatISO(now());
}

export function addDays(date, days) {
    const d = toDate(date);
    d.setDate(d.getDate() + days);
    return d;
}

export function addWeeks(date, weeks) {
    return addDays(date, weeks * 7);
}

export function addMonths(date, months) {
    const d = toDate(date);

    const day = d.getDate();

    d.setDate(1); // фикс — чтобы избежать переполнения
    d.setMonth(d.getMonth() + months);

    // возвращаем максимально возможный день
    const maxDay = new Date(
        d.getFullYear(),
        d.getMonth() + 1,
        0
    ).getDate();

    d.setDate(Math.min(day, maxDay));

    return d;
}

export function addAndFormat(date, {days = 0, weeks = 0, months = 0} = {}) {
    let d = toDate(date);

    if (days) d = addDays(d, days);
    if (weeks) d = addWeeks(d, weeks);
    if (months) d = addMonths(d, months);

    return formatDMYDash(d);
}

export function isBefore(a, b) {
    return getTime(a) < getTime(b);
}

export function isAfter(a, b) {
    return getTime(a) > getTime(b);
}

export function isFuture(date) {
    return isAfter(date, now());
}

export function isPast(date) {
    return isBefore(date, now());
}

export function isBetween(date, start, end) {
    const t = getTime(toDate(date));
    return t >= getTime(toDate(start)) && t <= getTime(toDate(end));
}

export function isActiveToday(endDate) {
    return isBetween(now(), startOfDay(now()), endDate);
}
